export default class LoyaltyLionStatus extends HTMLElement {
	constructor() {
		super();
		this.el = this;

		this.elLoyaltySatus = this.el.querySelectorAll('[data-points-required]');
		this.loyaltylionKey = this.el.dataset.loyaltylionKey;
		this.customerEmail = this.el.dataset.customerEmail;
	}

	async connectedCallback() {
		if (!this.loyaltylionKey || !this.customerEmail) return;

		const customer = await this.getCustomer(this.customerEmail);

		if (!customer) return;
		const {points_approved} = customer;

		this.displayStatus(points_approved);
	}

	async getCustomer(email = '') {
		try {
			const url = `https://api.loyaltylion.com/v2/customers?email=${email}`;
			const options = {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${this.loyaltylionKey}`,
				},
			};
			const response = await fetch(url, options);
			const data = await response.json();

			if (data.error) throw new TypeError(data.error.message);

			if (data.customers.length != 1)
				throw new TypeError('any or several customers found');

			return data.customers.find((element) => element);
		} catch (error) {
			console.log('error', error);
		}
	}

	displayStatus(points) {
		this.elLoyaltySatus.forEach((el) => {
			const pointsRequired = Number(el.dataset.pointsRequired);
			el.classList.add(
				points < pointsRequired ? 'u-opacity-50' : 'cs-points-required',
			);
		});
	}
}
